<template>
  <v-list :style="listContainer" class="py-0">
    <slot></slot>
  </v-list>
</template>

<script>
export default {
  name: 'List',
  props: {
    searchBox: {
      type: Boolean,
      default: false
    },
    fullscreen: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    searchBoxHeight: 0,
  }),
  computed: {
    offset() {
      return this.fullscreen ? 80 : 158;
    },
    listContainer() {
      const windowHeight = window.outerHeight;
      const headerHeight = 64;
      const paginationHeight =  44;
      const listContainerHeight = windowHeight - headerHeight - paginationHeight - this.searchBoxHeight - this.offset;
      return {
        height: listContainerHeight.toString() + 'px',
        overflow: 'auto'
      }
    },
  },
  watch: {
    searchBox(value) {
      if (value) {
        this.$nextTick(() => document.getElementById('searchBox').focus());
        this.searchBoxHeight = 72;
      } else {
        this.searchBoxHeight = 0;
      }
    },
  },
}
</script>

<style>

</style>